import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../utils/errors';

import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { TreatmentPlanV3State } from '../../types';
import type { TreatmentPlanV3InformationThunks } from './types';

export function addTreatmentPlanV3InformationCases(
  builder: ActionReducerMapBuilder<TreatmentPlanV3State>,
  thunks: TreatmentPlanV3InformationThunks,
) {
  const { getTreatmentPlanV3InformationPage } = thunks;

  builder
    .addCase(getTreatmentPlanV3InformationPage.pending, (state, action) => {
      state.informationPage = null;
      state.informationPageLoading = true;
      state.informationPageError = null;
      state.informationPageRequestId = action.meta.requestId;
      state.error = null;
    })
    .addCase(getTreatmentPlanV3InformationPage.fulfilled, (state, action) => {
      if (action.meta.requestId !== state.informationPageRequestId) return;
      state.informationPageLoading = false;
      state.informationPageError = null;
      state.informationPage = action.payload;
    })
    .addCase(getTreatmentPlanV3InformationPage.rejected, (state, action) => {
      if (action.meta.requestId !== state.informationPageRequestId) return;
      state.informationPageLoading = false;
      state.informationPageError = action.error;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}
